import { render } from "./AllTaskInbox.vue?vue&type=template&id=58b0dc1a"
import script from "./AllTaskInbox.vue?vue&type=script&lang=js"
export * from "./AllTaskInbox.vue?vue&type=script&lang=js"

import "./AllTaskInbox.vue?vue&type=style&index=0&id=58b0dc1a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__